import { SwiperSlide } from "swiper/react";
import { Container, Title, Carousel } from "../../shared/ui";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";
import { HotVacancyCard } from "../../entities/Vacancy";
import { useGetHotVacanciesQuery } from "../../entities/Vacancy/api/vacancyApi";
import {
    PlaceholderHotVacancyOne,
    PlaceholderHotVacancyThree,
    PlaceholderHotVacancyTwo,
} from "../../shared/assets/img";

import styles from "./HotVacancies.module.scss";
import { getRouteVacancy } from "../../shared/constants/routes";
import { CSSProperties } from "react";

export const HotVacancies = () => {
    const isMobile = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));

    const { data: hotVacancies } = useGetHotVacanciesQuery();

    let i = 0;

    const placeholders = [PlaceholderHotVacancyOne, PlaceholderHotVacancyTwo, PlaceholderHotVacancyThree];
    const { length } = placeholders;

    const slides = hotVacancies?.map((vacancy) => {
        i = i === length ? 0 : i;

        const slide = (
            <SwiperSlide key={vacancy.id} className={styles.slide}>
                <HotVacancyCard {...vacancy} to={getRouteVacancy(vacancy.id!)} background={placeholders[i]} />
            </SwiperSlide>
        );

        i++;

        return slide;
    });

    return (
        <Container marginSize={!isMobile ? "standard" : undefined} className={styles.container}>
            <Title className={styles.title} level={3}>
                Горячие вакансии
            </Title>
            <div className={styles.swiper}>
                <Carousel
                    spaceBetween={isMobile ? 0 : 20}
                    slidesOffsetBefore={isMobile ? 20 : 0}
                    slidesOffsetAfter={isMobile ? 20 : 0}
                    loop={false}
                    navigation="down"
                    navigationTheme="light"
                    className={styles.carousel}
                    style={{ "--space-between-slide": isMobile ? "0" : "20px" } as CSSProperties}
                >
                    {slides}
                </Carousel>
            </div>
        </Container>
    );
};
